module.exports = __webpack_public_path__ + "img/mappin.4ce89fc8.png";